import { C } from "@/lib/brand";

export default function ProgressBar({ current, total = 3 }) {
  return (
    <div data-testid="progress-bar" style={{ display: "flex", gap: 6, padding: "0 24px", maxWidth: 540, margin: "0 auto" }}>
      {Array.from({ length: total }).map((_, i) => {
        const idx = i + 1;
        const filled = idx <= current;
        return (
          <div
            key={i}
            data-testid={`progress-segment-${idx}`}
            style={{
              flex: 1,
              height: 4,
              background: filled ? C.peachDeep : "rgba(250,246,240,0.18)",
              transition: "background 240ms ease",
            }}
          />
        );
      })}
    </div>
  );
}
